import { render } from "./homeEduResearch.vue?vue&type=template&id=788c822a&scoped=true"
import script from "./homeEduResearch.vue?vue&type=script&lang=js"
export * from "./homeEduResearch.vue?vue&type=script&lang=js"

import "./homeEduResearch.vue?vue&type=style&index=0&id=788c822a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788c822a"]])

export default __exports__